import { SVGProps, Ref, forwardRef } from 'react';

export const CrossOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m7.01 8-4-4L4 3.01l4 4L12.01 3l.99.99L8.99 8 13 12.01l-.99.99L8 8.99 3.99 13 3 12.01z"
            fill="currentColor"
        />
    </svg>
));
CrossOutlinedSize16Glyph.displayName = 'CrossOutlinedSize16Glyph';
